import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { ICategoryItem, IItemCount } from '@shared/constants/models.const';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ContentService } from '../../../services/content.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { E_QPROPS } from '@shared/constants/enums.const';
import { HelperService } from '../../../services/helper.service';
import { CategoriesMobileComponent } from '@shared/components/categories-mobile/categories-mobile.component';

@UntilDestroy()
@Component({
  selector: 'app-categories',
  imports: [
    MatCheckbox,
    FormsModule,
    TranslateModule,
    CategoriesMobileComponent,
  ],
  templateUrl: './categories.component.html',
  styleUrl: './categories.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoriesComponent implements OnChanges {
  @Input() availableItems: IItemCount[] | undefined = []; // list of categories that we get from search result
  @Input() showMobileCategories!: boolean;
  list: ICategoryItem[] = []; // merged categories from search result and menu
  selectedContentType: number [] = []; // array of category type ids

  isAllChecked: boolean = true;
  isSomeChecked: boolean = true;

  latestCategoriesSum = 0;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public CONTENT: ContentService,
    public cd: ChangeDetectorRef,
    private HELPER: HelperService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    // TODO: Fix bug #5561977, issue happens because there is no this.HELPER.currentFrItem
    if (this.availableItems && this.availableItems?.length > 0) {
      setTimeout(() => {
        this.mergeCategoriesArrays(this.HELPER.currentFrItem?.searchableContentTypes, this.availableItems);
        this.getParamsFromUrl();
        this.cd.markForCheck();
      }, 100);

    }
  }

  getParamsFromUrl(): void {
    this.route.queryParams.pipe(untilDestroyed(this)).subscribe(params => {
      if (params && params[E_QPROPS.contentType]) {
        this.countSelectedCategories(params[E_QPROPS.contentType]);
      } else {
        this.setCategories();
      }
    });
  }

  // MERGE DATA WE GET FROM MENU WITH RESULT OF SEARCH
  mergeCategoriesArrays(array1: any[] = [], array2: IItemCount[] = []): void {
    this.list = [];
    const result: any[] = [];
    array1.forEach(item1 => {
      let itemIdMatch = array2?.find(item2 => item2.typeId === item1.id);
      if (itemIdMatch) {
        result.push({
          ...item1,
          ...itemIdMatch,
          checked: false,
        });
      }
    });
    this.list = result;
    this.cd.markForCheck();
  }

  // get a category ids array from a category sum
  countSelectedCategories(sum: number) {
    let powers = [];
    let power = 0;

    while (sum > 0) {
      if (sum % 2 !== 0) {
        powers.push(Math.pow(2, power));
      }
      sum = Math.floor(sum / 2);
      power++;
    }
    this.selectedContentType = [...powers.reverse()];
    if (this.selectedContentType.length == 0) {
      this.list = this.list.map(item => {return { ...item, checked: false };});
      this.isAllChecked = false;
      this.isSomeChecked = false;
    } else {
      this.list = this.list.map(item => {return { ...item, checked: this.selectedContentType.includes(item.typeId) };});
      this.isSomeChecked = true;
      this.isAllChecked = this.selectedContentType.length === this.list.length;
    }
  }

  setCategories(categoriesSum: number = 0) {

    const queryParams: any = {
      [E_QPROPS.contentType]: categoriesSum,
    };

    // reset pagination. but keep applied count items on page
    if (categoriesSum !== this.latestCategoriesSum) {
      this.latestCategoriesSum = categoriesSum;
      queryParams[E_QPROPS.skip] = 0;
    }

    this.router.navigate([], {
      queryParamsHandling: 'merge',
      skipLocationChange: false,
      queryParams,
      relativeTo: this.route,
    });

    this.cd.markForCheck();
  }

  updateAll(): void {
    this.list = this.list.map(item => {return { ...item, checked: !this.isAllChecked };});
    this.setParamsValue();
  }


  update(item: ICategoryItem): void {
    this.list = this.list.map(listItem => {
      return item.id === listItem.id ? { ...listItem, checked: !listItem.checked } : listItem;
    });
    this.setParamsValue();
  }

  setParamsValue(): void {
    const sumOfCheckedTypeIds = this.list.reduce((sum, obj) => {
      return obj.checked ? sum + obj.typeId : sum;
    }, 0);

    this.setCategories(sumOfCheckedTypeIds);
  }

  updateCategories(categories: ICategoryItem[]): void {
    this.list = [...categories];
    this.setParamsValue();
  }

}
